// src/services/httpService.js
import axios from "axios";
import CONSTANT from "../constant/constant"; 

const api = axios.create({
  baseURL: CONSTANT.API_BASE_URL, 
  headers: {
    "Content-Type": "application/json",
  },
});

// Add token to requests if it exists
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("jwt_token");
    if (token) {
      config.headers.Authorization = token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default api;